import React from 'react'
import Dropzone from 'react-dropzone'
import classnames from 'classnames'
import styles from './SlidesUploadModal.module.scss'
import Button from '@bt-react/components/Button'
import { IconType } from '@bt-react/components/Icon'
import { FileDropAreaProps } from './types'

export const FileDropArea = (props: FileDropAreaProps) => (
  <Dropzone
    className={classnames({
      [styles['drop-area']]: true
    })}
    onDrop={props.handleDrop}
    multiple={false}
    accept={'.ppt,.pptx'}
    maxSize={props.slidesSizeLimitBytes}
    onDropRejected={props.onDropRejected}
  >
    <span data-bdd='slides-upload-modal-drop-message'>Drag and Drop slides here</span>
    <span data-bdd='slides-upload-modal-drop-restrictions'>{`.ppt .pptx  |  Size limit ${props.slidesSizeLimitBytes / 1e+6}mb`}</span>
    <Button
      dataBdd="browse-button"
      onClick={() => {}}
      color={IconType.colour.secondary}
      text={'Browse files'}
    />
  </Dropzone>
)
